/**
 * ThreadLogo — the official Thread T-mark + wordmark.
 *
 * Uses the production T-mark SVG path from flight-sciences-media.
 * The wordmark is rendered as HTML text for reliable font fallback.
 */

interface Props {
  height?: number;
  showWordmark?: boolean;
  onClick?: () => void;
}

export function ThreadLogo({ height = 24, showWordmark = true, onClick }: Props) {
  const tMarkSize = height;
  const fontSize = height * 0.6;

  return (
    <span
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={onClick ? (e) => e.key === "Enter" && onClick() : undefined}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: height * 0.35,
        cursor: onClick ? "pointer" : undefined,
        userSelect: "none",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="3 4 107 90"
        width={tMarkSize}
        height={tMarkSize}
      >
        <path
          fill="#00643C"
          d="M 24.154178,91.432627 68.428669,21.741339 106.55535,21.756919 99.232728,33.346004 76.157969,33.464499 39.397767,91.445213 24.154181,91.432603 Z M 13.848206,75.227321 40.344233,33.492622 15.039021,33.459892 22.449877,21.716223 47.902188,21.690723 50.457494,17.588168 5.3424901,17.517908 12.680339,5.8254864 96.58386,5.8213064 89.196118,17.565173 H 65.624707 l -36.64469,57.681621 -15.131811,-0.01948 z"
        />
      </svg>
      {showWordmark && (
        <span
          style={{
            fontFamily: "'TWK Everett','Inter',-apple-system,system-ui,sans-serif",
            fontWeight: 700,
            fontSize,
            letterSpacing: "0.12em",
            color: "var(--thread-logo-color, #ffffff)",
            lineHeight: 1,
          }}
        >
          THREAD
        </span>
      )}
    </span>
  );
}
